export default __webpack_public_path__ + "static/media/map@2x.8464158a.jpg";